<ng-template #invoiceModalDetail let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h1 class="d-flex align-items-center h-fit">{{ 'INVOICE_DETAIL' | translate }} <span *ngIf="invoice.document_number">#{{ invoice.document_number }}</span>
      <ng-container *ngIf="invoice.status !== 'success'">
        <span class="badge badge-pill font-small-3 d-block w-fit ml-2" [ngClass]="{
                'badge-warning': invoice.status==='processing' || invoice.status==='processed',
                'badge-danger': invoice.status==='failed'
              }">{{ invoice.status_note || (invoice.status.toUpperCase() | translate) }}</span>
      </ng-container>
      <ng-container *ngIf="invoice.status == 'success'">
        <span *ngIf="invoice.cashed" class="badge badge-pill badge-success font-small-3 d-block w-fit ml-2">{{ 'CASHED' | translate }}</span>
        <span *ngIf="invoice.expired && !invoice.cashed" class="badge badge-pill badge-danger font-small-3 d-block w-fit ml-2">{{ 'EXPIRED' | translate }}</span>
        <span *ngIf="!invoice.cashed && !invoice.expired" class="badge badge-pill badge-warning font-small-3 d-block w-fit ml-2">{{ 'NOT_CASHED' | translate }}</span>
      </ng-container>
    </h1>
    <div class="row mt-3 mb-2">
      <div class="col-xl-6">
        <h3 class=" mb-1">{{ 'GENERAL_INFORMATION' | translate }}</h3>
        <div *ngIf="invoice.status==='processing' || invoice.status==='processed'">
          <p class="mb-05"><strong>{{ 'STATUS.STATUS' | translate }}:</strong> {{ invoice.status.toUpperCase() | translate }}</p>
          <p class="mb-05" *ngIf="!!invoice && !!invoice.status_note && invoice.status_note.length"><strong>{{ 'STATUS_NOTE' | translate }}:</strong> {{ invoice.status_note }}</p>
        </div>
        <p class="mb-05"><strong>{{ 'LAST_STATUS_UPDATED' | translate }}:</strong> {{ invoice.status_date | date:'dd/MM/y' }}</p>
        <p class="mb-05"><strong>{{ 'CREATED_BY' | translate }}:</strong> {{ invoice.creator.complete_name }}</p>
        <p class="mb-05"><strong>{{ 'CREATED_THE' | translate }}:</strong> {{ invoice.created_date | date: 'dd/MM/y' }}</p>
        <p class="mb-05"><strong>{{ 'DOCUMENT_CODE' | translate }}:</strong> {{ invoice.document_code }}</p>
      </div>
      <div class="col-xl-6">
        <h3 class=" mb-1">{{ 'PAYMENT_DETAIL' | translate }}</h3>
        <p class="mb-05"><strong>{{ 'PAYMENT_TERM' | translate }}:</strong> {{ invoice.payment_terms.name }}</p>
        <p class="mb-05"><strong>{{ 'BANK' | translate }}:</strong> {{ invoice.bank_name }}</p>
        <p class="mb-05"><strong>{{ 'IBAN' | translate }}:</strong> {{ invoice.bank_iban }}</p>
        <p class="mb-05"><strong>{{ 'EXPIRATION_DATE' | translate }}:</strong> {{ invoice.expiration_date | date: 'dd/MM/y' }}</p>
        <!--        <p class="mb-05"><strong>{{ 'CASHED' | translate }}:</strong> {{ (invoice.cashed ? 'YES' : 'NO') | translate }}</p>-->
        <p class="mb-05" *ngIf="invoice.cashed"><strong>{{ 'CASHED_DATE' | translate }}:</strong> {{ invoice.cashed_date | date:'dd/MM/y' }}</p>
      </div>
    </div>
    <div class="row mt-3 mb-2">
      <div class="col-xl-6">
        <h3 class=" mb-1">{{ 'CUSTOMER_DETAIL' | translate }}</h3>
        <p class="mb-05"><strong>{{ 'VAT_NUMBER' | translate }}:</strong> {{ invoice.client.vat_number }}</p>
        <p class="mb-05"><strong>{{ 'FISCAL_CODE' | translate }}:</strong> {{ invoice.client.fiscalcode }}</p>
        <p class="mb-05"><strong>{{ 'BUSINESS_NAME' | translate }}:</strong> {{ invoice.client.business_name }}</p>
      </div>
      <div class="col-xl-6">
        <h3 class="mb-1">{{ 'HEAD_OFFICE_DATA' | translate }}</h3>
        <p class="mb-05"><strong>{{ 'ADDRESS' | translate }}:</strong> {{ invoice.client.head_office?.street || '-' }}</p>
        <ng-container *ngIf="!!invoice && !!invoice.client.head_office">
          <div *ngIf="!invoice.client.head_office.external">
            <p class="mb-05"><strong>{{ 'ZIP_CODE' | translate }}:</strong> {{ invoice.client.head_office?.zipcode || '-' }}</p>
            <p class="mb-05"><strong>{{ 'CITY' | translate }}:</strong> {{ invoice.client.head_office?.city_name || '-' }}</p>
            <p class="mb-05"><strong>{{ 'PROVINCE' | translate }}:</strong> {{ invoice.client.head_office?.province_name || '-' }}</p>
          </div>
          <div *ngIf="invoice.client.head_office?.external">
            <p class="mb-05"><strong>{{ 'CITY' | translate }}:</strong> {{ invoice.client.head_office?.external_city || '-' }}</p>
            <p class="mb-05"><strong>{{ 'COUNTRY' | translate }}:</strong> {{ invoice.client.head_office?.country_name || '-' }}</p>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="row mt-3 mb-2">
      <div class="col-xl-6">
        <h3 class="mb-1">{{ 'INVOICE_DOCUMENT_INFORMATIONS' | translate }}</h3>
        <p class="mb-05"><strong>{{ 'INVOICE_TYPE' | translate }}:</strong> {{ invoice.invoice_type.name }}</p>
        <p class="mb-05"><strong>{{ 'DOCUMENT_DATE' | translate }}:</strong> {{ invoice.document_date | date: 'dd/MM/y' }}</p>
        <p class="mb-05"><strong>{{ 'DOCUMENT_NUMBER' | translate }}:</strong> {{ invoice.document_number || ('NOT_PROVIDED' | translate) }}</p>
        <p class="mb-05"><strong>{{ 'TOTAL_AMOUNT' | translate }}:</strong> {{ invoice.total_amount | currency: 'EUR' }}</p>
        <p class="mb-05 hidden"><strong>{{ 'CAUSAL' | translate }}:</strong> {{ invoice.invoice_type?.name }}</p>
        <p class="mb-05"><strong>{{ 'VAT' | translate }}:</strong> {{ invoice.vat_code }}%</p>
      </div>
      <div class="col-xl-6">
        <h3 class="mt-2 mb-1">{{ 'CLIENT_ORDER_DETAIL' | translate }}</h3>
        <p class="mb-05" *ngIf="invoice.order.number"><strong>{{ 'ORDER_NUMBER' | translate }}:</strong> {{ invoice.order.number }}</p>
        <p class="mb-05" *ngIf="invoice.order.date"><strong>{{ 'ORDER_DATE' | translate }}:</strong> {{ invoice.order.date | date: 'dd/MM/y' }}</p>
        <p class="mb-05" *ngIf="!!invoice.cig"><strong>{{ 'CIG' | translate }}:</strong> {{ invoice.cig }}</p>
        <p class="mb-05" *ngIf="!!invoice.cup"><strong>{{ 'CUP' | translate }}:</strong> {{ invoice.cup }}</p>
      </div>
    </div>
    <h3 class="mt-3 mb-1">{{ 'INVOICE_ROWS' | translate }}</h3>
    <ngx-datatable class="bootstrap core-bootstrap row" columnMode="force" [footerHeight]="0" [headerHeight]="30" [scrollbarH]="true"
                   [rowHeight]="_utilsService.isDesktop ? 60 : 350" [limit]="200" [rows]="invoice.rows">
      <ngx-datatable-column [name]="'NAME' | translate" prop="user.complete_name" [sortable]="true" *ngIf="_utilsService.isDesktop && !invoice.is_blank" class="bg-readonly">
        <ng-template ngx-datatable-cell-template let-row="row">
          <span placement="right" class="text-break-line-1" [ngbTooltip]="('EMPLOYEE' | translate)+'/'+('COLLABORATOR' | translate)" *ngIf="row.user.complete_name">{{ row.user.complete_name }}</span>
          <span placement="right" class="text-break-line-1" [ngbTooltip]="'PRODUCT' | translate" *ngIf="row.product.name">{{ row.product.name }}</span>
          <strong class="text-break-line-1" *ngIf="!row.user.complete_name && !row.product.name" placement="right" [ngbTooltip]="'GROUPED_ROWS' | translate">{{ 'GROUPED_ROWS' | translate }}</strong>
          <div *ngIf="!!row.month && !!row.year">({{ months[row.month - 1] | titlecase }} {{ row.year }})</div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [name]="'COMMISSION' | translate" prop="row_type_name" [sortable]="true" *ngIf="_utilsService.isDesktop && !invoice.is_blank">
        <ng-template ngx-datatable-cell-template let-row="row">
          <ng-container *ngIf="!!row.commission.id">
            <a *ngIf="row.user.complete_name" [routerLink]="['/dashboard/commission/edit', row.commission.id]" target="_blank" class="text-break-line-2" [ngbTooltip]="row.commission.complete_name" placement="left">{{ row.commission.complete_name }}</a>
            <a *ngIf="row.product.name" [routerLink]="['/dashboard/commissions/edit-product-commission', row.commission.id]" class="text-break-line-2" target="_blank" [ngbTooltip]="row.commission.complete_name" placement="left">{{ row.commission.complete_name }}</a>
          </ng-container>
          <ng-container *ngIf="!row.commission.id">
            <span>-</span>
          </ng-container>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [name]="'ROW_TYPE' | translate" prop="row_type_name" [sortable]="true" *ngIf="_utilsService.isDesktop">
        <ng-template ngx-datatable-cell-template let-row="row">
          <span [ngbTooltip]="row.row_type_name" placement="left">{{ row.row_type_name }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [name]="'SERVICE_DESCRIPTION' | translate" prop="service_description" [sortable]="true" *ngIf="_utilsService.isDesktop">
        <ng-template ngx-datatable-cell-template let-row="row">
          <div class="text-break-line-1" [ngbTooltip]="row.service_description" placement="left">{{ row.service_description }}</div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [name]="'VAT_CODE' | translate" prop="service_description" [sortable]="true" *ngIf="_utilsService.isDesktop">
        <ng-template ngx-datatable-cell-template let-row="row">
          <div class="text-break-line-1">{{ row.vat_code }}</div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [name]="'DESCRIPTION' | translate" prop="description" [sortable]="true" *ngIf="_utilsService.isDesktop">
        <ng-template ngx-datatable-cell-template let-row="row">
          <div class="text-break-line-2" placement="left" [ngbTooltip]="row.description">{{ row.description }}</div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [name]="'QUANTITY' | translate" prop="quantity" width="50" [sortable]="true" *ngIf="_utilsService.isDesktop">
        <ng-template ngx-datatable-cell-template let-row="row">{{ row.quantity }}</ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [name]="'PAYMENT_MEASURE_UNIT' | translate" prop="payment_measure_unit_name" [sortable]="true" *ngIf="_utilsService.isDesktop">
        <ng-template ngx-datatable-cell-template let-row="row">{{ row.payment_measure_unit_name }}</ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [name]="'UNITARY_PRICE' | translate" prop="payment_measure_unit_name" [sortable]="true" *ngIf="_utilsService.isDesktop">
        <ng-template ngx-datatable-cell-template let-row="row">{{ row.price | currency: 'EUR' }}</ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [name]="'TOTAL_AMOUNT' | translate" prop="payment_measure_unit_name" [sortable]="true" *ngIf="_utilsService.isDesktop">
        <ng-template ngx-datatable-cell-template let-row="row">{{ row.row_total_amount | currency: 'EUR' }}</ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</ng-template>